import {type ChangeEventHandler, useCallback, useMemo, useState} from 'react';

import {useEffectWithDeps} from 'src/hooks/useEffectWithDeps';
import {isDeepEqual} from 'src/utils/isDeepEqual';

import type {ResourceView} from '../typedef';

type Props = {
    records: ResourceView[],
};

export const useExpandRoles = ({records}: Props) => {
    const [expandedRoleIds, setExpandedRoleIds] = useState<string[]>([]);
    const [isExpanded, setIsExpanded] = useState<boolean>(false);

    const allRoleIds = useMemo(() => {
        return [...new Set(records
            .filter(({recordId}) => JSON.parse(recordId).roleId)
            .map(({recordId}) => JSON.parse(recordId).roleId),
        )];
    }, [records]);

    const toggleRolesExpansion = useCallback<ChangeEventHandler<HTMLInputElement>>(event => {
        const expanded = event.currentTarget.checked;
        if (expanded) {
            setExpandedRoleIds(allRoleIds);
            setIsExpanded(true);
        } else {
            setExpandedRoleIds([]);
            setIsExpanded(false);
        }
    }, [allRoleIds]);


    useEffectWithDeps((prev, current) => {
        if (!isDeepEqual({prev: prev.records, current: current.records})) {
            if (isExpanded) {
                setExpandedRoleIds(allRoleIds);
            } else {
                setExpandedRoleIds([]);
            }
        }
    }, {records, isExpanded, allRoleIds});

    return {
        expandedRoleIds,
        isExpanded,
        toggleRolesExpansion,
        setExpandedRoleIds,
        disabled: allRoleIds.length === 0,
    };
};
